<template>
  <div class="high-five-container" ref="highFive">
    <img width="375" height="255" class="high-five" :src="imageSource" />
  </div>
</template>
<script>
import { scrollParentBy } from "../utils";

export default {
  name: "HighFive",
  props: {
    questionElement: {
      type: Object,
      required: true,
    },
    quizAlreadyCompleted: { type: Boolean, required: true },
  },
  methods: {
    setImageSource() {
      const classList = document.documentElement.classList;
      if (
        classList.contains("theme-dark") ||
        (classList.contains("theme-auto") && this.prefersDark.matches)
      ) {
        this.imageSource = new URL(
          "@/assets/high_five_dark.gif",
          import.meta.url
        ).href;
      } else {
        this.imageSource = new URL(
          "@/assets/high_five.gif",
          import.meta.url
        ).href;
      }
    },
  },
  mounted() {
    if (!this.quizAlreadyCompleted) {
      scrollParentBy({ top: this.questionElement.offsetHeight / 2 });
    }
  },
  beforeMount() {
    this.setImageSource();
    this.prefersDark = window.matchMedia("(prefers-color-scheme: dark)");
    this.prefersDark.addEventListener("change", this.setImageSource);
    const observer = new MutationObserver((mutationList) => {
      for (const mutation of mutationList) {
        if (mutation.type === "attributes") {
          this.setImageSource();
        }
      }
    });
    observer.observe(document.documentElement, {
      attributes: true,
      attributeOldValue: true,
      attributeFilter: ["class"],
    });
  },
  data() {
    return {
      imageSource: "",
      prefersDark: false,
    };
  },
};
</script>
<style lang="scss">
.high-five-container {
  display: flex;
  justify-content: center;
  align-items: center;
}

.high-five {
  width: 100%;
  max-width: 375px;
  display: block;
}
</style>
